var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"comment-progress"},[_c('i',{staticClass:"fa fa-check-square-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"comment-progress__status"},[_vm._v("\n\t\t"+_vm._s(this.completed)+"/"+_vm._s(this.total)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }